// extracted by mini-css-extract-plugin
module.exports = {"container":"pagenav_container__37tjJ","item":"pagenav_item__2gmXM"};